import { render, staticRenderFns } from "./SelectBox.vue?vue&type=template&id=fc534850&scoped=true&"
import script from "./SelectBox.vue?vue&type=script&lang=js&"
export * from "./SelectBox.vue?vue&type=script&lang=js&"
import style0 from "./SelectBox.vue?vue&type=style&index=0&id=fc534850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc534850",
  null
  
)

export default component.exports